//renders representational component
import React from 'react'
import Timer from './timer'
import '../css/print.css';

import {
  ListGroupItem,
  ListGroup,
  PanelGroup,
  Tab,
  Tabs,
  Panel
} from '../../node_modules/react-bootstrap/lib/';

import RaceConfig from './race-config'
import ResultsTable from './results-table'
import ProcessAthletesList from './process-athletes-list'

import ParticipantRegisterSimulation from './participant-list-simulation'
import ParticipantRegisterTouch from './participant-list-touch'
import ParticipantRegisterKeyboard from './participant-list-keyboard'
import ParticipantVisualization from './participant-visualization'

import {
  race_stats_label,
  import_label,
  info_label,
  config_label,
  cronometro_label,
  registro_label,
  race_visualization_label,
  stats_label
} from '../constants/icons';

import RaceInfo from './race-info'
import RaceStats from './race-stats'


class HomePage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: 1
    };

    this.handleTabSelect =
      this.handleTabSelect.bind(this);
  }


  /*
   * -------------------------------------------------------
   * TAB ACTIVA
   * -------------------------------------------------------
   *
   * Visualización solamente se monta cuando
   * realmente estamos mirando esa pestaña.
   *
   * Esto evita que 500/600 atletas sean
   * procesados en cada REGISTER_TIME mientras
   * estamos usando Simulación, Teclado o Touch.
   */
  handleTabSelect(activeTab) {

    this.setState({
      activeTab
    });
  }


  render() {

    const {
      activeTab
    } = this.state;


    return (

      <div className="timer-page">

        <Tabs
          activeKey={activeTab}
          onSelect={this.handleTabSelect}
          id="timer-main-tabs"
        >


          {/*
           * ==========================================
           * CONFIGURACION
           * ==========================================
           */}

          <Tab
            eventKey={1}
            title={config_label}
          >

            <Panel>

              <ListGroup fill>

                <ListGroupItem>

                  <RaceConfig />

                </ListGroupItem>

              </ListGroup>

            </Panel>

          </Tab>


          {/*
           * ==========================================
           * IMPORTAR
           * ==========================================
           */}

          <Tab
            eventKey={2}
            title={import_label}
          >

            <Panel>

              <ListGroup fill>

                <ListGroupItem>

                  <ProcessAthletesList />

                </ListGroupItem>

              </ListGroup>

            </Panel>

          </Tab>


          {/*
           * ==========================================
           * CRONOMETRO
           * ==========================================
           */}

          <Tab
            eventKey={3}
            title={cronometro_label}
          >

            <Timer
              updateInterval={1000}
            />

          </Tab>


          {/*
           * ==========================================
           * REGISTRO
           * ==========================================
           */}

          <Tab
            eventKey={4}
            title={registro_label}
          >

            <ListGroup fill="true">

              <ListGroupItem>

                <PanelGroup>


                  <Panel
                    id="registro-manual"
                    collapsible
                    header="Manual"
                    defaultExpanded
                    eventKey="1"
                  >

                    <div className="container">

                      <ParticipantRegisterKeyboard />

                    </div>

                  </Panel>


                  <Panel
                    id="registro-tactil"
                    collapsible
                    header="T&aacute;ctil"
                    eventKey="2"
                  >

                    <div className="wrapper">

                      <ParticipantRegisterTouch />

                    </div>

                  </Panel>


                  <Panel
                    id="registro-simulacion"
                    collapsible
                    header="Simular"
                    eventKey="3"
                  >

                    <ParticipantRegisterSimulation />

                  </Panel>


                </PanelGroup>

              </ListGroupItem>

            </ListGroup>

          </Tab>


          {/*
           * ==========================================
           * RESULTADOS
           * ==========================================
           */}

          <Tab
            eventKey={5}
            title={stats_label}
          >

            <ResultsTable />

          </Tab>


          {/*
           * ==========================================
           * INFO
           * ==========================================
           */}

          <Tab
            eventKey={6}
            title={info_label}
          >

            <RaceInfo />

          </Tab>


          {/*
           * ==========================================
           * ESTADISTICAS
           * ==========================================
           */}

          <Tab
            eventKey={7}
            title={race_stats_label}
          >

            <RaceStats />

          </Tab>


          {/*
           * ==========================================
           * VISUALIZACION
           * ==========================================
           *
           * IMPORTANTE:
           *
           * ParticipantVisualization NO existe
           * mientras esta pestaña no está activa.
           *
           * Por lo tanto, durante una simulación de
           * 600 atletas no procesa los 600 cambios
           * de Redux.
           */}

          <Tab
            eventKey={8}
            title={race_visualization_label}
          >

            {
              activeTab === 8
                ? (
                    <ParticipantVisualization />
                  )
                : null
            }

          </Tab>


        </Tabs>

      </div>
    );
  }
}


export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/homePage.js